// Local calendar dates (YYYY-MM-DD) and schedules. Weekdays are ISO: 1 = Monday … 7 = Sunday.

export const localDate = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const shiftDate = (iso: string, days: number) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + days);
  return localDate(d);
};

/** ISO weekday of a YYYY-MM-DD date. */
export const isoWeekday = (iso: string) => {
  const day = new Date(`${iso}T12:00:00`).getDay();
  return day === 0 ? 7 : day;
};

/** Short weekday names in the user's language, Monday first (index 0 = ISO 1). */
export const weekdayNames = (style: "short" | "long" = "short", locale?: string) =>
  [1, 2, 3, 4, 5, 6, 7].map((n) =>
    // 2024-01-01 was a Monday.
    new Date(2024, 0, n).toLocaleDateString(locale, { weekday: style }),
  );

/**
 * "Every day", "Weekdays", "Weekends", or the days listed ("Mon, Tue, Thu").
 * Returns null for on-demand (no days).
 */
export function scheduleDays(
  days: number[],
  labels: { everyDay: string; weekdays: string; weekends: string },
  names = weekdayNames(),
): string | null {
  const set = [...new Set(days)].sort((a, b) => a - b);
  if (set.length === 0) return null;
  if (set.length === 7) return labels.everyDay;
  if (set.join() === "1,2,3,4,5") return labels.weekdays;
  if (set.join() === "6,7") return labels.weekends;
  return set.map((d) => names[d - 1]).join(", ");
}
